import {Box, IconButton, Tooltip, Typography} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import {useEffect, useRef, useState} from "react";
import {snackbar} from "../../utils/snackbar";

const CopyableTextHoverOnly = ({value, label = "Valor", emptyText = "-"}) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  if (!value) return emptyText;

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      snackbar.info(`${label} copiado al portapapeles`);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      snackbar.error(`Error al copiar ${label}: ` + (error.message || "Inténtalo de nuevo."));
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        height: "100%",
        width: "100%",
        "&:hover .copy-button": {
          opacity: 1
        }
      }}
    >
      <Typography variant="body2" noWrap title={value} sx={{flex: 1, minWidth: 0}}>
        {value}
      </Typography>
      <Tooltip title={copied ? "Copiado" : `Copiar ${label}`}>
        <IconButton
          className="copy-button"
          aria-label={`Copiar ${label}`}
          color="primary"
          size="small"
          onClick={handleCopy}
          sx={{
            opacity: 0,
            transition: "opacity 0.2s",
            flexShrink: 0
          }}
        >
          {copied ? <CheckIcon fontSize="inherit" /> : <ContentCopyIcon fontSize="inherit" />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CopyableTextHoverOnly;
